export abstract class DsIconConfig {
  enableMobileAutoresize: boolean;
}
